import { Divider } from "@portal/BaseComponents/Divider/AntDivider";
import { FilterDropDownButton } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropDownButton";
import { FilterStrip } from "@portal/BaseComponents/Filters/Strip/FilterStrip";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { MenuClick } from "@portal/BaseComponents/Menu/type";
import { customFieldAtom } from "@portal/store/Filters/customFields/custom-field";
import { disputeFiltersAtom } from "@portal/store/Filters/dipsutes/dispute-filter";
import { defaultDisputeKeys } from "@portal/store/Filters/dipsutes/predicate";
import { DefaultDisputeKeys } from "@portal/store/Filters/dipsutes/type";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";
import { Fragment, useMemo } from "react";
import { CreatedDateFilter } from "./CreatedDate/CreatedDateFilter";
import { DisputeStatusFilter } from "./DipsuteStatus/DisputeStatusFilter";
import { DisputeAmountFilter } from "./DisputeAmount/DisputeAmountFilter";
import { DisputeTypesFilter } from "./DisputeTypes/DisputeTypes";
import { useCustomFieldsQuery } from "@portal/queries/custom-field-query";
import { CustomFiledFilterGeneric } from "@portal/BaseComponents/Filters/Elements/CustomField/CustomFiledFilter";
import { Skeleton } from "antd";

function DisputeFilters() {
  const [disputeFilters, setDisputeFilters] = useAtom(disputeFiltersAtom);
  const setFilters = useSetAtom(disputeFiltersAtom);
  const { data, isLoading } = useCustomFieldsQuery("DISPUTE", setFilters);
  const [customFieldFilter, setCustomField] = useAtom(customFieldAtom);
  function getSelectedFilterKeys() {
    return [
      ...disputeFilters.activeFilterKeys,
      ...(customFieldFilter.selectedKeys.DISPUTES ?? []),
    ];
  }

  function handleClick(e: MenuClick["0"]) {
    if (defaultDisputeKeys.includes(e.key as DefaultDisputeKeys)) {
      setDisputeFilters((prev) => {
        return produce(prev, (draft) => {
          draft.activeFilterKeys.push(e.key as DefaultDisputeKeys);
        });
      });
      return;
    }
    setCustomField((filed) => {
      return produce(filed, (draft) => {
        draft.selectedKeys.DISPUTES?.push(e.key);
        return draft;
      });
    });
  }

  const customFieldFilters = data ? (
    <Fragment>
      {data.map((field) => {
        return (
          <CustomFiledFilterGeneric
            customField={field}
            key={field.display_name}
            customFieldKey="DISPUTES"
          />
        );
      })}
    </Fragment>
  ) : null;

  const selectedValues = useMemo(getSelectedFilterKeys, [
    customFieldFilter.selectedKeys,
    disputeFilters.activeFilterKeys,
  ]);

  return (
    <FilterStrip width="362px">
      <DisputeStatusFilter />
      <Flex align="start">
        <Divider type="vertical" style={{ margin: 0, height: "32px" }} />
        <Flex style={{ width: "100%" }} wrap>
          <DisputeTypesFilter />
          <CreatedDateFilter />
          <DisputeAmountFilter />
          {isLoading ? <Skeleton.Input /> : customFieldFilters}
          <FilterDropDownButton
            handleClick={handleClick}
            items={disputeFilters.filterGroup}
            selectedValues={selectedValues}
            key={selectedValues.length}
          />
        </Flex>
      </Flex>
    </FilterStrip>
  );
}

export { DisputeFilters };
